import { NgModule } from '@angular/core';
import { CallcardModelService } from './callcard-model/callcard-model.service';
import { CCallerBaseModelService } from './ccallerbase-model/ccallerbase-model.service';
import { CEventModelService } from './cevent-model/cevent-model.service';
import { CLocationBaseModelService } from './clocationbase-model/clocationbase-model.service';
import { CStampCardModelService } from './cstampcard-model/cstampcard-model.service';
import { UnitActivityModelService } from './unitactivity-model/unitactivity-model.service';

@NgModule({
  imports: [],
  exports: [],
  providers: [
    CallcardModelService,
    CCallerBaseModelService,
    CEventModelService,
    CLocationBaseModelService,
    CStampCardModelService,
    UnitActivityModelService
  ]
})
export class SagaModelsServiceModule {}
